/**
 * @file: 挂钉渲染
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../../../cubeTree/index';
import * as Toolkit from '../../../toolkit/index';
import * as Utils from '../../../utils/util';
import * as FrontCubeData from '../../../frontCubeData/index';

interface HangnailDetail {
    backSpace: number,
    backYspace: number
    hangnailDetail: string,
    hangnailLength: number,
    hangnailNum: number,
    hangnailType: number,
    holeNum: number,
    labelHeight: number,
    labelWidth: number,
    labelXspace: number,
    labelYspace: number,
    slopeHeight: number
}

export function renderNail(cube: CubeNode): void {
    if (renderDisable(cube)) {
        return;
    }

    let nailData: HangnailDetail = FrontCubeData.getValue(cube.id, 'hangnailDetail');
    let nailBg: JQuery<HTMLElement> = createNailBG(nailData);
    let lines: JQuery<HTMLElement> = createLines(nailData);
    let nailBox: JQuery<HTMLElement> = cube.jView.find('.default-nail-box');

    Toolkit.html(nailBox, '');
    nailBox.append(nailBg).append(lines);

    let backYspace: number = Toolkit.cmToPx(nailData.backYspace);
    cube.jView.css({
        marginTop: backYspace
    });
}

function createNailBG(nailData: HangnailDetail): JQuery<HTMLElement> {
    let $result: JQuery<HTMLElement> = $(document.createElement('div')).addClass('nail-bg');
    let backYspace: number = Toolkit.cmToPx(nailData.backYspace);

    $result.css({
        top: -10 - backYspace
    });

    return $result;
}

function createLines(nailData: HangnailDetail): JQuery<HTMLElement> {
    let $result: JQuery<HTMLElement> = $(document.createElement('div')).addClass('nail-line-box');
    let backYspace: number = Toolkit.cmToPx(nailData.backYspace);
    let holeNum: number = Utils.toNumberForce(nailData.holeNum);

    $result.css({
        top: -backYspace,
        height: Math.abs(backYspace),
        width: Toolkit.cmToPx(holeNum * 2.5),
        left: '50%',
        marginLeft: -Toolkit.cmToPx(holeNum * 2.5) / 2
    });
    for (let i: number = 0; i < holeNum; i++) {
        $result.append($(document.createElement('div')).addClass('nail-line'));
    }

    return $result;
}

function renderDisable(cube: CubeNode): boolean {
    let parentCube: CubeNode = CubeTree.findParentCubeByCubeId(cube.id);
    let nailId: number = FrontCubeData.getValue(cube.id, 'hangnailId');
    let nailData: HangnailDetail = FrontCubeData.getValue(cube.id, 'hangnailDetail');

    return !nailId || !nailData || !CubeTree.isBeam(parentCube.id);
}
